<template>
    <div class="page-container user-profile-container">
      <b-container>
        <div>
          <div class="ft-notification">
            <b-row>
              <div class="alert-col">
                  <b-alert show variant="warning" class="ft-alert" style="display: flex; flex-direction: row; align-items: flex-start;">
                            <div class="alert-content" style="">
                                <p>{{$t('message.banner.bannerActiveText', [getSupplierName])}}
                                </p>
                            </div>
                            <div style="position: absolute; right: 1rem">
                                <add-supplier-modal />
                            </div>
                        </b-alert>
                  </div>
              </b-row>
          </div>
        </div>
      </b-container>
      <b-row style="height:76px;width:100%;margin:0px;padding:0px;background-color:white">
        <!-- <b-col cols="3" style="height:76px;align-self:center;">
          <div class="user-info-profile" style="width:36px;height:36px;background-color:#EBEBEB;margin-left:50%;border-radius:18px">
            <b-form-text class="user-profile-text">PK</b-form-text>
          </div>
        </b-col> -->
        <b-col cols="7" style="height:76px;align-self:center;">
            <b-form-text  class="user-name" style="margin-top:16px">{{demandDetail.value.supplier_name}}</b-form-text>
            <b-form-text  class="mobile-number">+91{{demandDetail.value.contact}}</b-form-text>
        </b-col>
      </b-row>
      <div style="margin-top:10px;margin-bottom:10px;margin-left:16px">
          <h6>{{ $t('message.preferred_routes') }}</h6>
      </div>
      <div class="profile-routes-container">
          <div class="ft-list-group">
             <b-list-group >
                <b-list-group-item v-for="(preferredRoute,index) in preferredRoutes" v-bind:key="'preferredRoute'+index" class="d-flex justify-content-between align-items-center">
                  <div class="list-item-content">
                  {{preferredRoutes[index].origin}}
                  <icon-base icon-name="swap" width="24" height="24" viewbox="0 0 24 24">
                    <icon-swap/>
                  </icon-base>
                  {{preferredRoutes[index].destination}}
                  </div>
                  <b-button class="ft-btn-delete" variant="link" @click="deleteRoute(preferredRoute, index, $event.target)">
                    <icon-base icon-name="delete" width="24" height="24" viewbox="0 0 24 24">
                      <icon-delete/>
                    </icon-base>
                  </b-button>
              </b-list-group-item>
            </b-list-group>
          </div>
      </div>
      <AddPreferredRoutesModal @add-route="add_Route" :routes_list="routes_list"/>
      <b-row class="btn-fixed-bottom-route">
        <b-col>
          <b-button type="submit" variant="dark" block @click="onAddRoute">
              {{ $t('message.addRoutes_preferred') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
</template>
<script>
//import RouteModal from '../components/modals/LoadRouteModal.vue';
// import DemandDetailsCard from '../components/DemandDetailsCard.vue'

import AddSupplierModal from '../components/AddSupplierModal.vue'
import IconBase from '../components/IconBase.vue'
import IconDelete from '../components/icons/IconDelete.vue'
import IconSwap from '../components/icons/IconSwap.vue'
import AddPreferredRoutesModal from '../components/modals/AddPreferredRouteModal.vue';
import axios from "axios";
import {MX_TRACK} from '../utils/Mixpanel.js'

import config from '../config/config.js'
// const API_BASE_URL = process.env.VUE_APP_API_PHASE2_BASE_URL

export default {
  name: "TruckAvailability",
  components: {
   // RouteModal,
   // DemandDetailsCard
   // AddSupplierModal,
    IconBase,
    IconDelete,
    IconSwap,

   AddPreferredRoutesModal,
   AddSupplierModal
  },
  data() {
    return {
        showRouteModal:false,
        showLoader:false,
        routes_list: {},
        routes_dup: {},
        showSaveBtnLoader: false,
        preferredRoutes:[],
        origin:'',
        destination:"",
        demandDetail:''
    }
  },
  methods: {
    async onAddRoute() {
      //alert("add_routge")
      const mxData = {}
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ATTEMPT_TO_ADD_PREFERRED_ROUTE, mxData)
        this.$root.$emit('on-add-preferred-route', null);
    },
    add_Route() {
      this.getPreferredRoutes()
      // console.log("route",JSON.stringify(route))
      // this.routes_list=route
      // this.routes_dup=route
      // this.origin = route.origin
      // this.destination = route.destination
      //
      //this.unLoadingPointOptions = unLoadingPointOptions

    },
    async deleteRoute(item) {
       const mxData = {origin:item.origin,destination:item.destination}
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ATTEMPT_TO_DELETE_PREFERRED_ROUTE, mxData)
        this.$confirm({
        title: this.$t('message.deletePreferredRouteText1'),
        message: this.$t('message.deletePreferredRouteText2', [`${item.origin} - ${item.destination}`]),
        button: {
          yes: this.$t('message.modalConfirmOkBtnText'),
          no: this.$t('message.modalCancelBtnText')
        },
        callback: async (confirm) => {
          if (confirm == true) {
            const {data} = await axios.delete(`/supplier_routes/${this.$route.params.id}/route/${item.id}/delete`)
            if(data.success){
              this.trackMixpanelEvent(config.MIXPANEL_EVENTS.DELETE_PREFERRED_ROUTE, mxData)
              this.preferredRoutes.splice(this.preferredRoutes.findIndex(a => a.id === item.id), 1)
            }
          }
        }
      })
    },
    async getPreferredRoutes(){
      const {data} = await axios.get(`/supplier_routes/${this.$route.params.id}/list`)
      if (data.success) {
        this.preferredRoutes=data.value
      }
    },
    async trackLoadProfile(){
      const mxData = {}
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LOAD_USER_PROFILE_PAGE, mxData)
    },
    trackMixpanelEvent(event, data = {}) {
        const demandDetails = this.$store.getters.getDemandDetails.value
        const mx_prop = {
          time: new Date().getTime(),
          page_src: this.$route.name,
          user_type: demandDetails.user_type,
          user_name: demandDetails.supplier_name,
          phone_number: demandDetails.contact,
          language: this.$route.params.lang,
          demand_id: demandDetails.demand_id,
          bid_status: demandDetails.status,
        }
        MX_TRACK(event, {...mx_prop, ...data})
    },
    cacheId() {
      localStorage.setItem('demand_supply_id', this.$route.params.id)
    }
  },
  watch: {
    '$store.state.demandDetails': {
      immediate: true,
      handler() {
        this.demandDetail = this.$store.getters.getDemandDetails
      }
    }
  },
  computed: {
    getSupplierName() {
      return this.demandDetail.value.supplier_name
    }
  },
  mounted() {
    this.trackLoadProfile();
    this.getPreferredRoutes();
    this.cacheId();
  },
}
</script>

<style lang="scss">

.user-profile-container {
  background-color: #F5F5F5;
  
  .alert-content {
    width: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.load-more-container {
  margin-top: 80px;
}

.ui-confirmdialog-message {
  white-space: pre-line;
}

.btn-fixed-bottom-route {
  margin-bottom: 10px;
}
// .user-info .user-name{
//   font-size: 14px;
//   line-height: 20px;
//   font-weight: 400;
//   font-style: normal;
//   font: Roboto;
//   color:#1F1F1F !important;
// }
// .mobile-number{
//   font-size: 12px;
//   line-height: 16px;
//   font-weight: 400;
//   font-style: normal;
// }


.user-info-profile .user-profile-text{
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  font-style: normal;
  font: Roboto;
  margin-left:24%;
  margin-top:54%;
  padding-top:20%;
  color:#707070 !important;
}

.profile-routes-container {
  margin-top: 0.5rem;
}

@media (max-width: 576px) {

  .user-profile-container {
    overflow-y: auto;
    min-height:750px;
    max-height: 850px;
    padding-bottom: 50px;
  }

  .load-more-container {
    margin-top: 60px;
    margin-bottom: 100px;
  }

  .btn-fixed-bottom-route {
      position: fixed;
      bottom: 0;
      width: 100%;
     // align-self: center;
      margin-left:1.5%;
      //background-color: white;
      z-index: 5;
      padding-top:20px;
      padding-bottom:20px;
      margin-bottom: 0px;
  }
    .route-text {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
    }
    .placeholder-text{
      text-align: left;
    }
    .title-text{
      text-align: left;
    }
    @media (max-width: 576px) {
        .btn-fixed-bottom {
            position: fixed;
            bottom: 0;
            width: 100%;
            background-color: white;
            z-index: 5;
            padding-top:20px;
            padding-bottom:20px;
            margin-bottom: 0px;
        }
        @media (min-height: 550px) and (max-height:570px){
          .user-profile-container{
            min-height:250px;
            max-height:250px;
            background-color:#F5F5F5;
          }
          .list-group {
              max-height: 300px;
              overflow: auto;
          }
        }
        @media (min-height:570px) and (max-height: 720px){
          .user-profile-container{
            min-height:500px;
            background-color:#F5F5F5 ;
          }
          .list-group {
              max-height: 380px;
              overflow: auto;
          }
        }
        @media (min-height:721px) and (max-height: 800px){
          .user-profile-container{
            min-height:580px;
            background-color:#F5F5F5;
          }
          .list-group {
              max-height: 470px;
              overflow: auto;
          }
        }
        @media (min-height:800px) and (max-height: 830px){
          .user-profile-container{
            min-height:670px;
            background-color:#F5F5F5 ;
          }
          .list-group {
              max-height: 550px;
              overflow: auto;
          }
        }
    }
}
// @media (min-height: 720px) and (max-height: 850px) {
//   .user-profile-container{
//     min-height: 720px;
//     background-color:#F5F5F5 ;
//   }
// }

</style>
